import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EmailPerformanceDashboard = lazy(() =>
  import("@scenes/AnalyticsDashboard/EmailPerformanceDashboard").then((module) => ({
    default: module.EmailPerformanceDashboard,
  }))
);

export const emailPerformanceNRO: NavigationRoutingObject = {
  Component: EmailPerformanceDashboard,
  componentFeatureFlippers: [],
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("email-analytics-dashboard-sidebar-pill-menu-option", "Email Performance"),
  pageNameForTracking: () => "Email Performance",
  getDeveloperNavigationAllowed: ({ isImpersonating, hasPermission }) => {
    const userHasViewAppUsagePermission = hasPermission("appGroup", {
      permission: "viewAppUsage",
    });

    return isImpersonating || userHasViewAppUsagePermission;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("email-performance-alt-keyword-1", "Email engagement"),
        t("email-performance-alt-keyword-2", "Email sends"),
        t("email-performance-alt-keyword-3", "Delivery rate"),
        t("email-performance-alt-keyword-4", "Bounce rate"),
        t("email-performance-alt-keyword-5", "Unsubscribe rate"),
        t("email-performance-alt-keyword-6", "Unique open rate"),
        t("email-performance-alt-keyword-7", "Other open rate"),
        t("email-performance-alt-keyword-8", "Unique click rate"),
        t("email-performance-alt-keyword-9", "Click-to-open rate"),
        t("email-performance-alt-keyword-10", "Mailbox providers"),
        t("email-performance-alt-keyword-11", "Time of engagement"),
        t("email-performance-alt-keyword-12", "Deliverability center"),
        t("email-performance-alt-keyword-13", "Google postmaster integration"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  noKnockoutFallback: true,
};
